import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { SearchField } from '../search-field/search-field';
import { NoResults } from './no-results/no-results';
import { Avatar } from '@doxyme/ui';
import { InfiniteScrollHandler } from './infinite-scroll-handler/infinite-scroll-handler';
import { makeFilterOptionsComponentClass as cn } from './filter-options.helper';
import './filter-options.scss';
export var SectionType;
(function (SectionType) {
    SectionType["All"] = "all";
    SectionType["Recent"] = "recent";
    SectionType["Main"] = "main";
    SectionType["Location"] = "location";
})(SectionType || (SectionType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["All"] = "All";
    FilterType["Provider"] = "Provider";
    FilterType["Room"] = "Room";
    FilterType["Location"] = "Location";
})(FilterType || (FilterType = {}));
export const FilterOptions = ({ visibleSections, searchValue, setSearchValue, isOptionSelected, onOptionSelect, handleInfiniteScrollEndReach, className = '', isOnCall, }) => {
    const intl = useIntl();
    const [DropDownHeight, setDropDownHeight] = useState(0);
    const [isSearchVisible, setIsSearchVisible] = useState(true);
    useEffect(() => {
        if (!searchValue) {
            const recent = visibleSections.find((x) => x.type === SectionType.Recent);
            const main = visibleSections.find((x) => x.type === SectionType.Main);
            const isSearch = (recent ? recent.options.length : 0) + main.options.length > 10;
            setIsSearchVisible(isSearch);
        }
    }, [visibleSections, searchValue]);
    useEffect(() => {
        if (!searchValue && isOnCall) {
            const recent = visibleSections.find((x) => x.type === SectionType.Recent);
            const main = visibleSections.find((x) => x.type === SectionType.Main);
            const locations = visibleSections.find((x) => x.type === SectionType.Location);
            let height = 24;
            if (isSearchVisible) {
                height += 40 + 16;
            }
            if (recent && recent.options.length > 0) {
                height += recent.options.length * 48 + 54;
            }
            if (main && main.options.length > 0) {
                height +=
                    Math.min(main.options.length, 9 - (recent ? recent.options.length : 0)) * 48;
                if (main.options.length > 9) {
                    height += -24 - 8;
                }
            }
            if (locations && locations.options.length > 0) {
                height += locations.options.length * 48 + 54;
            }
            setDropDownHeight(height);
        }
    }, [visibleSections, searchValue, isSearchVisible, isOnCall]);
    return (<InfiniteScrollHandler className={`${cn('wrapper')} ${className}`} onReachEnd={handleInfiniteScrollEndReach} height={DropDownHeight}>
      {isSearchVisible && (<SearchField value={searchValue} onSearch={setSearchValue} placeholder={intl.formatMessage({
                id: 'account.analytics.filter.placeholder',
            })}/>)}
      {visibleSections.map((section) => (<div className={cn('section')} key={section.type}>
          {section.label && (<div className={cn('section-label')}>{section.label}</div>)}
          {section.options.map((option) => (<button className={cn([
                    'option',
                    isOptionSelected(option) && 'option_selected',
                ])} onClick={() => onOptionSelect(option)} key={option.reactKey}>
              {option.imageUrl && (<Avatar className={cn('avatar')} src={option.imageUrl}/>)}
              {option.iconName && (<Avatar className={cn([
                        'avatar',
                        'avatar_generic-clinic',
                        `avatar_${option.iconName}`,
                    ])} iconName={option.iconName}/>)}
              {!option.iconName &&
                    !option.imageUrl &&
                    option.type === FilterType.All && (<Avatar className={cn(['avatar', 'avatar_generic-clinic'])} iconName="clinic-generic-picture"/>)}
              {!option.iconName &&
                    !option.imageUrl &&
                    option.type === FilterType.Provider && (<Avatar className={cn(['avatar', 'avatar_generic-user'])} iconName="user"/>)}
              {!option.iconName &&
                    !option.imageUrl &&
                    option.type === FilterType.Room && (<Avatar className={cn(['avatar', 'avatar_generic-waiting-room'])} iconName="waiting-room"/>)}
              {!option.iconName &&
                    !option.imageUrl &&
                    option.type === FilterType.Location && (<Avatar className={cn(['avatar', 'avatar_generic-location'])} iconName="location"/>)}
              <div className={cn('option-label-text')}>
                {option.optionLabel}
              </div>
            </button>))}
          {section.showDividerAfter && (<div className={cn('section-divider')}/>)}
        </div>))}
      {!visibleSections.length && <NoResults />}
    </InfiniteScrollHandler>);
};
